/**
 * Traduce mensajes de error técnicos de las aseguradoras a mensajes amigables para el usuario
 */
export const translateInsuranceError = (errorMessage: string, companyName: string = ''): string => {
  if (!errorMessage) {
    return 'No se pudo obtener la cotización. Por favor, intenta nuevamente.';
  }

  const lowerError = errorMessage.toLowerCase();
  const lowerCompany = companyName.toLowerCase();

  // Errores relacionados con vehículo no existe
  if (
    lowerError.includes('vehículo no existe') ||
    lowerError.includes('el vehiculo no existe') ||
    lowerError.includes('vehicle does not exist') ||
    lowerError.includes('vehiculo no disponible')
  ) {
    return `Lo sentimos, este vehículo no está disponible para cotizar en ${companyName || 'esta aseguradora'} en este momento. Por favor, verifica los datos del vehículo o intenta con otro modelo.`;
  }

  // Errores relacionados con suma asegurada
  if (
    lowerError.includes('suma asegurada excede') ||
    lowerError.includes('suma asegurada excede lo autorizado') ||
    lowerError.includes('excede lo autorizado') ||
    lowerError.includes('valor excede') ||
    lowerError.includes('exceeds authorized') ||
    lowerError.includes('0066')
  ) {
    return `Lo sentimos, el valor de este vehículo excede los límites permitidos por ${companyName || 'esta aseguradora'}. Por favor, contacta con un agente para más información.`;
  }

  // Errores relacionados con web service inactivo
  if (
    lowerError.includes('ws no está activo') ||
    lowerError.includes('web service no está activo') ||
    lowerError.includes('servicio no disponible') ||
    lowerError.includes('service not available')
  ) {
    return `Lo sentimos, el servicio de cotización de ${companyName || 'esta aseguradora'} no está disponible temporalmente. Por favor, intenta nuevamente más tarde.`;
  }

  // Errores relacionados con datos inválidos
  if (
    lowerError.includes('datos inválidos') ||
    lowerError.includes('invalid data') ||
    lowerError.includes('información incorrecta')
  ) {
    return `Lo sentimos, algunos datos del vehículo o conductor no son válidos para ${companyName || 'esta aseguradora'}. Por favor, verifica la información e intenta nuevamente.`;
  }

  // Errores relacionados con cobertura no disponible
  if (
    lowerError.includes('cobertura no disponible') ||
    lowerError.includes('coverage not available') ||
    lowerError.includes('plan no disponible')
  ) {
    return `Lo sentimos, el plan seleccionado no está disponible para este vehículo en ${companyName || 'esta aseguradora'}. Por favor, intenta con otro plan.`;
  }

  // Errores genéricos de Qualitas
  if (lowerError.includes('qualitas') && lowerError.includes('error')) {
    return `Lo sentimos, no se pudo obtener la cotización de Qualitas. Por favor, intenta nuevamente o contacta con un agente.`;
  }

  // Errores genéricos de ANA
  if (lowerError.includes('ana') && lowerError.includes('error')) {
    return `Lo sentimos, no se pudo obtener la cotización de ANA Seguros. Por favor, intenta nuevamente o contacta con un agente.`;
  }

  // Si el mensaje ya es amigable o no coincide con ningún patrón, retornarlo tal cual
  // pero asegurándonos de que incluya el nombre de la compañía si no lo tiene
  if (companyName && !lowerError.includes(lowerCompany)) {
    return `${companyName}: ${errorMessage}`;
  }

  return errorMessage;
};

/**
 * Obtiene el nombre de la compañía desde un mensaje de error
 */
export const extractCompanyFromError = (errorMessage: string): string => {
  if (!errorMessage) return '';

  const lowerError = errorMessage.toLowerCase();

  if (lowerError.includes('qualitas')) {
    return 'Qualitas';
  }

  if (lowerError.includes('ana')) {
    return 'ANA Seguros';
  }

  return '';
};

